// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Db from "../../backend/Db.bs.jsx";
import * as Styles from "../../styles/components/Styles.bs.jsx";
import * as ReactIntl from "react-intl";
import * as FormattedVolume from "../../components/FormattedVolume/FormattedVolume.bs.jsx";
import * as FormattedCurrency from "../../components/FormattedCurrency/FormattedCurrency.bs.jsx";
import * as SectionWithHeader from "../../components/SectionWithHeader/SectionWithHeader.bs.jsx";
import * as JsxRuntime from "react/jsx-runtime";
import ChargedKegsModuleCss from "./ChargedKegs.module.css";

let classes = ChargedKegsModuleCss;

function ChargedKegs(props) {
  let onKegDetail = props.onKegDetail;
  let onAddNewKeg = props.onAddNewKeg;
  let chargedKegs = props.chargedKegs;
  return <SectionWithHeader.make
    buttonsSlot={<button
      className={Styles.button.base}
      type={"button"}
      onClick={param => onAddNewKeg()}
    >
      {"Přidat sud"}
    </button>}
    headerId={"charged_kegs_setting"}
    headerSlot={"Sudy na skladě"}
  >
    {chargedKegs.length !== 0 ? <table
        className={classes.table}
      >
        <thead>
          <tr>
            <th
              scope={"col"}
            >
              {"No."}
            </th>
            <th
              scope={"col"}
            >
              {"Pivo"}
            </th>
            <th
              scope={"col"}
            >
              {"Naskladněno"}
            </th>
            <th
              scope={"col"}
            >
              {"Cena"}
            </th>
            <th
              scope={"col"}
            >
              {"Objem"}
            </th>
            <th
              scope={"col"}
            >
              {"Zbývá"}
            </th>
          </tr>
        </thead>
        <tbody>
          {chargedKegs.map(keg => {
            let kegId = Db.getUid(keg);
            let volume = keg.milliliters;
            return <tr
              key={kegId} 
              onClick={param => onKegDetail(kegId)}
            >
              <th
                scope={"row"}
              >
                {keg.serialFormatted}
              </th>
              <td>
                {keg.beer}
              </td>
              <td>
                <ReactIntl.FormattedDate
                  value={keg.createdAt.toDate()}
                />
              </td>
              <td>
                <FormattedCurrency.make
                  value={keg.price}
                />
              </td>
              <td>
                <FormattedVolume.make
                  milliliters={volume}
                />
              </td>
              <td>
                <FormattedVolume.make
                  milliliters={volume - keg.consumptionsSum | 0}
                />
              </td>
            </tr>;
          })}
        </tbody>
      </table> : <div
        className={classes.emptyTableMessage}
      >
        {"Naskladni sudy tlačítkem ⤴"}
      </div>}
  </SectionWithHeader.make>;
}

let make = ChargedKegs;

export {
  classes,
  make,
}
/* classes Not a pure module */
